import { render } from "./Category.vue?vue&type=template&id=b921197a&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=b921197a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b921197a"

export default script